const INEGI_API_KEY = process.env.REACT_APP_INEGI_KEY || '';

export const getVehicleTypeForINEGI = (unit) => {
    if (!unit) return 1;

    // Según la documentación del INEGI:
    // v=1: Automóvil (2 ejes)
    // v=2: Camión (3+ ejes)
    // v=3: Autobús
    if (unit === 5) return 1; // Automóvil
    if (unit === 1 || unit === 2 ) return 2; // Van/Sprinter/Beccar
    if (unit === 3 || unit === 4) return 3; // Autobús
    return 2; // Default
};

// Función para buscar destinos en INEGI
export const searchINEGIDestination = async (cityName) => {
    try {
        const response = await fetch('https://gaia.inegi.org.mx/sakbe_v3.1/buscadestino', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                buscar: cityName,
                type: 'json',
                num: 5,
                key: INEGI_API_KEY // En producción usar token real
            })
        });

        const data = await response.json();
        if (data.response.success && data.data && data.data.length > 0) {
            return data.data[0].id_dest; // Retorna el primer resultado
        }
        throw new Error('No se encontró el destino');
    } catch (error) {
        console.error('Error buscando destino:', error);
        return null;
    }
};

// Función para calcular ruta y costos con API INEGI
export const calculateRouteWithId = async (originCity, destinationCity, selectedUnit) => {

    try {
        // Calcular ruta preferentemente cuota (incluye casetas)
        const vehicleType = getVehicleTypeForINEGI(selectedUnit);

        const routeResponse = await fetch('https://gaia.inegi.org.mx/sakbe_v3.1/cuota', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                dest_i: originCity,
                dest_f: destinationCity,
                v: vehicleType,
                type: 'json',
                proj: 'MERC',
                key: INEGI_API_KEY // Reemplazar con token real
            })
        });

        const routeData = await routeResponse.json();

        if (routeData.response.success) {
            return {
                distancia_km: routeData.data.long_km,
                tiempo_min: routeData.data.tiempo_min,
                costo_caseta: routeData.data.costo_caseta,
                geojson: routeData.data.geojson,
            };
        }

        throw new Error('Error calculando la ruta');

    } catch (error) {
        console.error('Error con API INEGI:', error);
        throw error;
    }
};

export const searchINEGIByCoordinates = async (lat, lng, escala = 10000) => {
    try {

        const response = await fetch('https://gaia.inegi.org.mx/sakbe_v3.1/buscalinea', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                x: lng,        // Longitud (¡ojo: x es longitud!)
                y: lat,        // Latitud (y es latitud)
                escala: escala, // Escala de visualización
                type: 'json',
                key: INEGI_API_KEY
            })
        });

        const data = await response.json();

        if (data.response.success && data.data) {
            return {
                id_routing_net: data.data.id_routing_net,
                source: data.data.source,
                target: data.data.target,
                nombre: data.data.nombre,
                geojson: data.data.geojson
            };
        }
        throw new Error('No se encontraron líneas cercanas');
    } catch (error) {
        console.error('Error buscando por coordenadas:', error);
        return null;
    }
};

export const getFuel = async (type) => {
    try {
        const response = await fetch(
            'https://gaia.inegi.org.mx/sakbe_v3.1/combustible',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    type: 'json',
                    key: INEGI_API_KEY
                }),
            }
        );

        const data = await response.json();

        if (!data?.response?.success || !Array.isArray(data.data)) {
            throw new Error('No se encontraron datos de combustible');
        }

        // Mapeo de tu número al tipo de combustible
        const fuelTypes= {
            1: 'Premium',
            2: 'Diésel',
            3: 'Regular',
            4: 'Gas',
        };

        const fuelName = fuelTypes[type];

        if (!fuelName) {
            throw new Error(`Tipo de combustible no válido: ${type}`);
        }

        // Buscar dentro del array
        const fuel = data.data.find((item) => item.tipo === fuelName);

        if (!fuel) {
            throw new Error(`No se encontró el combustible: ${fuelName}`);
        }

        return fuel.costo; // { tipo, tipo_costo, costo }

    } catch (error) {
        console.error('Error buscando combustible:', error);
        return null;
    }
};


export const calculateRouteWithCoordinates = async (startLat, startLng, endLat, endLng, routeType = 'cuota', vehicle) => {
    try {
        console.log('vehicle', vehicle);
        // 1. Buscar líneas cerca de los puntos
        const startLine = await searchINEGIByCoordinates(startLat, startLng);
        const endLine = await searchINEGIByCoordinates(endLat, endLng);

        if (!startLine || !endLine) {
            throw new Error('No se encontraron líneas de transporte cercanas');
        }

        // 2. Calcular la ruta usando los endpoints correctos
        const routeEndpoints = {
            'optima': 'https://gaia.inegi.org.mx/sakbe_v3.1/optima',
            'cuota': 'https://gaia.inegi.org.mx/sakbe_v3.1/cuota',
            'libre': 'https://gaia.inegi.org.mx/sakbe_v3.1/libre'
        };

        const vehicleType = getVehicleTypeForINEGI(vehicle);

        const routeResponse = await fetch(routeEndpoints[routeType], {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                id_i: startLine.id_routing_net.toString(),
                source_i: startLine.source.toString(),
                target_i: startLine.target.toString(),
                id_f: endLine.id_routing_net.toString(),
                source_f: endLine.source.toString(),
                target_f: endLine.target.toString(),
                v: vehicleType, // Tipo de vehículo
                type: 'json',
                proj: 'MERC',
                key: INEGI_API_KEY
            })
        });

        const routeData = await routeResponse.json();

        if (routeData.response.success) {
            return {
                distancia_km: routeData.data.long_km,
                tiempo_min: routeData.data.tiempo_min,
                costo_caseta: routeData.data.costo_caseta,
                geojson: routeData.data.geojson,
                startLine,
                endLine
            };
        }

        throw new Error('Error calculando la ruta');

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const calculateMultiPointRoute = async (coordinates, routeType = 'cuota', vehicle, optimize = true) => {
    try {
        if (!coordinates || coordinates.length < 2) {
            throw new Error('Se necesitan al menos 2 puntos para calcular una ruta');
        }

        let optimizedCoordinates = [...coordinates];

        // Optimizar ruta si hay waypoints y la optimización está habilitada
        if (optimize && coordinates.length > 2) {
            const origin = coordinates[0];
            const destination = coordinates[coordinates.length - 1];
            const waypoints = coordinates.slice(1, -1); // Waypoints intermedios

            const optimizedWaypoints = await optimizeWaypoints(origin, waypoints);

            // Reconstruir array optimizado
            optimizedCoordinates = [
                origin,
                ...optimizedWaypoints,
                destination
            ];

            console.log('Ruta optimizada:', {
                original: coordinates.map(c => c.name),
                optimized: optimizedCoordinates.map(c => c.name)
            });
        }

        const routes = [];
        let totalDistance = 0;
        let totalTime = 0;
        let totalCost = 0;

        // Calcular ruta para cada segmento
        for (let i = 0; i < optimizedCoordinates.length - 1; i++) {
            const startPoint = optimizedCoordinates[i];
            const endPoint = optimizedCoordinates[i + 1];

            const segmentRoute = await calculateRouteWithCoordinates(
                startPoint.lat,
                startPoint.lng,
                endPoint.lat,
                endPoint.lng,
                routeType,
                vehicle
            );

            if (!segmentRoute) {
                throw new Error(`Error calculando ruta de ${startPoint.name} a ${endPoint.name}`);
            }

            routes.push({
                from: startPoint.name,
                to: endPoint.name,
                segment: i + 1,
                ...segmentRoute
            });

            // Acumular totales
            totalDistance += parseFloat(segmentRoute.distancia_km);
            totalTime += parseInt(segmentRoute.tiempo_min);
            totalCost += parseFloat(segmentRoute.costo_caseta);
        }

        return {
            optimized: optimize && coordinates.length > 2,
            originalOrder: coordinates.map(c => c.name),
            optimizedOrder: optimizedCoordinates.map(c => c.name),
            segments: routes,
            totals: {
                distancia_km: totalDistance.toFixed(2),
                tiempo_min: totalTime,
                tiempo_total_horas: (totalTime / 60).toFixed(1),
                costo_caseta: totalCost.toFixed(2),
            }
        };

    } catch (error) {
        console.error('Error calculando ruta multipunto:', error);
        return null;
    }
};
export const calculateAdvancedMultiRoute = async (coordinates, options = {}) => {
    const {
        routeType = 'optima',
        vehicleType = 1, // 1=auto, 2=moto, etc.
        includeDetails = false
    } = options;

    try {
        const routes = [];
        const allGeojson = []; // Para combinar todas las geometrías

        for (let i = 0; i < coordinates.length - 1; i++) {
            const startPoint = coordinates[i];
            const endPoint = coordinates[i + 1];

            // Calcular ruta del segmento
            const segmentRoute = await calculateRouteWithCoordinates(
                startPoint.lat, startPoint.lng,
                endPoint.lat, endPoint.lng,
                routeType
            );

            if (!segmentRoute) continue;

            // Si se requiere detalle, obtener itinerario
            let segmentDetail = null;
            if (includeDetails) {
                segmentDetail = await getRouteDetail(
                    segmentRoute.startLine,
                    segmentRoute.endLine,
                    routeType,
                    vehicleType
                );
            }

            routes.push({
                segment: i + 1,
                from: startPoint.name,
                to: endPoint.name,
                route: segmentRoute,
                detail: segmentDetail
            });

            // Agregar geometría
            if (segmentRoute.geojson) {
                allGeojson.push(segmentRoute.geojson);
            }
        }

        // Calcular totales
        const totals = routes.reduce((acc, route) => {
            acc.distance += parseFloat(route.route.distancia_km);
            acc.time += parseInt(route.route.tiempo_min);
            acc.cost += parseFloat(route.route.costo_caseta);
            return acc;
        }, { distance: 0, time: 0, cost: 0 });

        return {
            segments: routes,
            totals: {
                distancia_km: totals.distance.toFixed(2),
                tiempo_min: totals.time,
                tiempo_horas: (totals.time / 60).toFixed(1),
                costo_casetas: totals.cost.toFixed(2)
            },
            geometries: allGeojson
        };

    } catch (error) {
        console.error('Error:', error);
        return null;
    }
};

// Función auxiliar para obtener detalle de ruta
export const getRouteDetail = async (startLine, endLine, routeType, vehicleType) => {
    const detailEndpoints = {
        'optima': 'https://gaia.inegi.org.mx/sakbe_v3.1/detalle_o',
        'cuota': 'https://gaia.inegi.org.mx/sakbe_v3.1/detalle_c',
        'libre': 'https://gaia.inegi.org.mx/sakbe_v3.1/detalle_l'
    };

    try {
        const response = await fetch(detailEndpoints[routeType], {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                id_i: startLine.id_routing_net.toString(),
                source_i: startLine.source.toString(),
                target_i: startLine.target.toString(),
                id_f: endLine.id_routing_net.toString(),
                source_f: endLine.source.toString(),
                target_f: endLine.target.toString(),
                v: vehicleType.toString(),
                type: 'json',
                key: INEGI_API_KEY
            })
        });

        const data = await response.json();
        return data.response.success ? data.data : null;
    } catch (error) {
        console.error('Error obteniendo detalle:', error);
        return null;
    }
};


// Función para calcular distancia entre dos puntos (CORREGIDA - sin async)
const calculateDistance = (point1, point2) => {
    const R = 6371; // Radio de la Tierra en km
    const dLat = (point2.lat - point1.lat) * Math.PI / 180;
    const dLng = (point2.lng - point1.lng) * Math.PI / 180;
    const a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(point1.lat * Math.PI / 180) * Math.cos(point2.lat * Math.PI / 180) *
        Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
};

// Optimizar waypoints usando algoritmo del vecino más cercano
const optimizeWaypoints = async (start, waypoints) => {
    if (!waypoints || waypoints.length === 0) return [];

    const unvisited = [...waypoints];
    const optimized = [];
    let currentPoint = start;

    while (unvisited.length > 0) {
        let nearestIndex = 0;
        let nearestDistance = calculateDistance(currentPoint, unvisited[0]);

        for (let i = 1; i < unvisited.length; i++) {
            const distance = calculateDistance(currentPoint, unvisited[i]);
            if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = i;
            }
        }

        const nearest = unvisited.splice(nearestIndex, 1)[0];
        optimized.push(nearest);
        currentPoint = nearest;
    }

    return optimized;
};


// Función auxiliar para calcular un solo segmento
const calculateSingleSegment = async (originId, destinationId, vehicleType) => {
    const routeResponse = await fetch('https://gaia.inegi.org.mx/sakbe_v3.1/cuota', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            dest_i: originId,
            dest_f: destinationId,
            v: vehicleType,
            type: 'json',
            proj: 'MERC',
            key: INEGI_API_KEY
        })
    });

    const routeData = await routeResponse.json();

    if (routeData.response.success) {
        return {
            distancia_km: routeData.data.long_km,
            tiempo_min: routeData.data.tiempo_min,
            costo_caseta: routeData.data.costo_caseta,
            geojson: routeData.data.geojson,
        };
    }

    throw new Error('Error calculando el segmento de ruta');
};

// Nueva función para calcular ruta con waypoints
export const calculateRouteWithWaypoints = async (originId, waypointIds, destinationId, selectedUnit) => {
    try {
        const vehicleType = getVehicleTypeForINEGI(selectedUnit);

        // Construir array de puntos: origen → waypoints → destino
        const points = [originId, ...waypointIds, destinationId];

        // Calcular cada segmento
        const segments = [];
        for (let i = 0; i < points.length - 1; i++) {
            const segment = await calculateSingleSegment(
                points[i],
                points[i + 1],
                vehicleType
            );
            segments.push(segment);
        }

        // Sumar todos los valores
        const totalRoute = segments.reduce((acc, segment) => ({
            distancia_km: acc.distancia_km + segment.distancia_km,
            tiempo_min: acc.tiempo_min + segment.tiempo_min,
            costo_caseta: acc.costo_caseta + segment.costo_caseta,
            geojson: acc.geojson // Puedes combinar los geojson si lo necesitas
        }), {
            distancia_km: 0,
            tiempo_min: 0,
            costo_caseta: 0,
            geojson: null
        });

        return {
            ...totalRoute,
            segments, // Incluir detalle de cada segmento
            totalSegments: segments.length
        };

    } catch (error) {
        console.error('Error calculando ruta con waypoints:', error);
        throw error;
    }
};